import { InjectionToken } from '@angular/core';
import { environment } from '../../../environments/environment';

export interface StrapiConfig {
  baseUrl: string;
  apiPrefix: string;
  /**
   * Strapi read token. Server-only — factory reads process.env at render
   * time, client bundle resolves this to ''. Attached by
   * strapiAuthInterceptor on SSR requests only. In Strapi v5 the same
   * read-only token covers both published and draft content (draft access
   * is gated at the URL via ?status=draft, not at the token scope), so
   * one token serves both public reads and preview-mode reads.
   */
  apiToken: string;
  /**
   * HMAC secret used by the server-only preview-cookie verifier. Never
   * read directly by any Angular-app file — the verifier provider in
   * app.config.server.ts reads this at SSR render time and uses it to
   * validate the `__samotics_preview` cookie. Empty string on the client
   * bundle (client never verifies cookies).
   */
  previewSecret: string;
}

export const STRAPI_CONFIG = new InjectionToken<StrapiConfig>('StrapiConfig', {
  providedIn: 'root',
  factory: () => ({
    baseUrl: environment.strapiBaseUrl,
    apiPrefix: '/api',
    apiToken: (typeof process !== 'undefined' && process.env?.['STRAPI_API_TOKEN']) || '',
    previewSecret: (typeof process !== 'undefined' && process.env?.['PREVIEW_SECRET']) || '',
  }),
});
